"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputDefaultProps = exports.INSET_ELEMENT_DEFAULTS = exports.FOOTER_TEXT_FONT_SIZE = exports.FOOTER_TEXT_FONT_COLOR = exports.DISABLED_ICON_OFFSET = void 0;
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
const inputDefaultProps = exports.inputDefaultProps = {
  display: 'block'
};
const DISABLED_ICON_OFFSET = exports.DISABLED_ICON_OFFSET = 24;
const INSET_ELEMENT_DEFAULTS = exports.INSET_ELEMENT_DEFAULTS = {
  width: 13,
  inset: 15
};
const FOOTER_TEXT_FONT_COLOR = exports.FOOTER_TEXT_FONT_COLOR = (0, _utils.token)('color.text.secondary');
const FOOTER_TEXT_FONT_SIZE = exports.FOOTER_TEXT_FONT_SIZE = (0, _utils.token)('text.size.100');